import { render, staticRenderFns } from "./AlarmPage.vue?vue&type=template&id=6cfd751e"
import script from "./AlarmPage.vue?vue&type=script&lang=js"
export * from "./AlarmPage.vue?vue&type=script&lang=js"
import style0 from "./AlarmPage.vue?vue&type=style&index=0&id=6cfd751e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports